module.exports = __webpack_public_path__ + "static/@Domain-Pools-Australia_1-9ee4444807ecd9bac9c49279a5572712.jpg";